import React, { useState } from 'react';
import api from '../services/api';

const TestVehicleCreator = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const createTestVehicle = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    
    try {
      // Create a test vehicle
      const testVehicle = {
        name: `Test Vehicle ${new Date().toISOString()}`,
        registration_number: `KBZ-${Math.floor(1000 + Math.random() * 9000)}`,
        type: 'SUV',
        make: 'Toyota',
        model: 'Land Cruiser',
        model_year: 2023,
        capacity: 7,
        fuel_type: 'Diesel',
        mileage: 5000,
        status: 'active',
        is_active: true,
        features: ['Air Conditioning', 'GPS', '4x4', 'Roof Rack']
      };
      
      console.log('Creating test vehicle:', testVehicle);
      
      // Use the correct API endpoint according to the system's configuration
      const response = await api.post('/api/v1/admin/vehicles', testVehicle);
      
      console.log('Test vehicle creation response:', response.data);
      setResult(response.data);
      
      // Fetch vehicles to verify
      const vehiclesResponse = await api.get('/api/v1/admin/vehicles');
      console.log('Vehicles after creation:', vehiclesResponse.data);
    } catch (error) {
      console.error('Error creating test vehicle:', error);
      setError(error.message || 'An error occurred');
      
      if (error.response) {
        console.error('Error response data:', error.response.data);
        setError(`${error.message} - ${JSON.stringify(error.response.data)}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 bg-white shadow rounded-lg">
      <h2 className="text-xl font-semibold mb-4">Test Vehicle Creator</h2>
      
      <button
        onClick={createTestVehicle}
        disabled={loading}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
      >
        {loading ? 'Creating...' : 'Create Test Vehicle'}
      </button>
      
      {error && (
        <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          <p className="font-bold">Error:</p>
          <p>{error}</p>
        </div>
      )}
      
      {result && (
        <div className="mt-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
          <p className="font-bold">Success:</p>
          <pre className="mt-2 overflow-auto">{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default TestVehicleCreator;
